// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ImYb","comment":"styles_comment__1APaB"};